
import React, { useEffect, useState } from "react";
import { BASE_IMAGE_API_GET } from "../services/baseServices";
import MainLayout from "../layouts/MainLayout";
import { Popover } from 'antd';
import Swal from 'sweetalert2';
import 'react-tooltip/dist/react-tooltip.css';
import '../assets/styles/loader.css';
import '../assets/styles/pagination.css';
// import ViewContentByType from "../components/contentByType/view";
// import AddContentByType from "../components/contentByType/add";
// import EditContentByType from "../components/contentByType/edit";
import axios from "axios";
import AddOrganization from "../components/organizations/add";
import { fetchOrganizations, inActiveOrganization } from "../services/organizationServices";
import EditOrganization from "../components/organizations/edit";
import { useNavigate } from "react-router-dom";

export default function OrganizationList() {

    const [sessionUserData, setSessionUserData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [organizationsData, setOrganizationsData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [editData, setEditData] = useState({});
    const [selectedImage, setSelectedImage] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setSessionUserData(userData);
        } else {
            navigate("/");
        }
    }, [navigate]);

    const getOrganizations = async () => {
        try {
            const data = await fetchOrganizations();
            setOrganizationsData(data);
        } catch (error) {
            console.error('Failed to load organizations:', error);
        } finally {
            console.log('Organization fetch completed');
        }
    };

    useEffect(() => {
        getOrganizations();
    }, []);

    const filteredData = organizationsData && organizationsData?.filter((item) => {
        const orgname = item?.OrgName?.toLowerCase() || '';

        const query = searchQuery.toLowerCase();

        return (
            orgname.includes(query)
        );
    });

    const handleEdit = (item) => {
        setEditData(item);
    };

    const imageStyle = {
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        objectFit: 'cover',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
        cursor: 'pointer',
        border: '2px solid #e0f2fe',
        backgroundColor: '#fff'
    };

    const recordsPerPage = 5;
    const totalPages = filteredData?.length ? Math.ceil(filteredData?.length / recordsPerPage) : 0;

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData?.slice(indexOfFirstRecord, indexOfLastRecord);

    const getPaginationNumbers = () => {
        const visiblePages = [];
        if (totalPages <= 6) {
            for (let i = 1; i <= totalPages; i++) visiblePages.push(i);
        } else {
            if (currentPage <= 3) {
                visiblePages.push(1, 2, 3, "...", totalPages - 2, totalPages - 1, totalPages);
            }
            else if (currentPage > 3 && currentPage < totalPages - 2) {
                visiblePages.push(1, 2, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages - 1, totalPages);
            }
            else {
                visiblePages.push(1, 2, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            }
        }
        return visiblePages;
    };

    const handlePageClick = (page) => {
        if (page !== "...") setCurrentPage(page);
    };

    const handlePrevious = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handleDelete = async (item) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to delete organization "${item.OrgName}"?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            try {

                const response = await inActiveOrganization({
                    OrgId: item.OrgId,
                    UpdatedBy: sessionUserData?.Id,
                });

                if (response.data.ResultData.Status === 'Success') {
                    Swal.fire('Deleted!', 'The organization has been deleted.', 'success');
                    getOrganizations();
                } else {
                    Swal.fire('Delete!', 'Failed to delete organization, try after sometime..!.', 'error');
                }

            } catch (error) {
                console.error('Error deleting organization:', error);
                Swal.fire('Error', 'Something went wrong!', 'error');
            } finally {
                console.log();
            }
        }
    };

    return (
        <MainLayout>
            <div className="content">
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4 className="fw-bold">Organizations</h4>
                            <h6>Manage your organizations</h6>
                        </div>
                    </div>
                    <ul className="table-top-head">
                        <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"><i className="ti ti-refresh"></i></a>
                        </li>

                    </ul>
                    <div className="page-btn">
                        <a href="#" className="btn btn-primary"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightAdd"
                            aria-controls="offcanvasRightAdd">
                            <i className="ti ti-circle-plus me-1"></i>New Organization
                        </a>
                    </div>
                </div>

                <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <div className="search-set">
                            <div className="search-input">
                                <span className="btn-searchset"><i className="ti ti-search fs-14 feather-search"></i></span>
                                <input type="search" className="form-cotrol" placeholder="Search" />
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table">
                                <thead className="thead-light">
                                    <tr>
                                        <th className="no-sort">#</th>
                                        <th>Name</th>
                                        <th>Logo</th>
                                        <th>Email</th>
                                        <th>Phone No</th>
                                        <th className="text-center">Address</th>
                                        <th>Status</th>
                                        <th className="no-sort">Action</th>
                                    </tr>
                                </thead>
                                <tbody className="fw-semibold text-gray-600">
                                    {dataLoading ? (
                                        <tr>
                                            <td colSpan="12" className="text-center">
                                                <div className="container"></div>
                                            </td>
                                        </tr>
                                    ) : currentRecords && currentRecords.length > 0 ? (
                                        currentRecords?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{(currentPage - 1) * recordsPerPage + index + 1}</td>
                                                <td>
                                                    <a
                                                        className="text-gray-800 text-hover-primary mb-1"
                                                        title={item.OrgName}
                                                    >
                                                        {item.OrgName.length > 30 ? `${item.OrgName.slice(0, 30)}...` : item.OrgName}
                                                    </a>
                                                </td>
                                                <td className="text-info">
                                                    <div
                                                        className="d-inline-flex align-items-center justify-content-center rounded-circle"
                                                        style={{
                                                            width: "60px",
                                                            height: "60px",
                                                            border: "2px solid #e0f2fe",
                                                            backgroundColor: "#fff",
                                                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                                                            overflow: "hidden",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() => setSelectedImage(`${BASE_IMAGE_API_GET}${item.ImageUrl}`)}
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#imagePreviewModal"
                                                    >
                                                        <img
                                                            src={`${BASE_IMAGE_API_GET}${item.ImageUrl}`}
                                                            alt="Img"
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "contain",
                                                                padding: "4px",
                                                            }}
                                                        />
                                                    </div>
                                                </td>
                                                <td title={`${item.EmailId}`}>
                                                    {item.EmailId ? (
                                                        item.EmailId.length > 30
                                                            ? `${item.EmailId.slice(0, 30)}...`
                                                            : item.EmailId
                                                    ) : 'N/A'}
                                                </td>
                                                <td>
                                                    {item.PhoneNo || 'N/A'}
                                                </td>
                                                <td className="text-center">
                                                    <i
                                                        className="fa-solid fa-location-dot fa-lg"
                                                        title={item.Address || 'No address available'}
                                                        style={{
                                                            cursor: 'pointer',
                                                            transition: 'transform 0.2s',
                                                        }}
                                                        onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                                        onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                    ></i>
                                                </td>
                                                <td>
                                                    <div className={`badge bg-soft-${item.IsActive ? 'success' : 'danger'}`}>
                                                        {item.IsActive ? 'Active' : 'Inactive'}
                                                    </div>
                                                </td>
                                                <td className="">
                                                    <Popover
                                                        placement="bottom"
                                                        content={
                                                            <div style={{ width: '8rem' }}>
                                                                <p
                                                                    className="text-hover-warning"
                                                                    data-bs-toggle="offcanvas"
                                                                    data-bs-target="#offcanvasRightEdit"
                                                                    aria-controls="offcanvasRightEdit"
                                                                    onClick={() => handleEdit(item)}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        transition: 'transform 0.2s',
                                                                    }}
                                                                    onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                                                    onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                                >
                                                                    <i className="fa-regular fa-pen-to-square me-2 text-info"></i>
                                                                    Edit
                                                                </p>
                                                                <p
                                                                    className="text-hover-warning"
                                                                    onClick={() => handleDelete(item)}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        transition: 'transform 0.2s',
                                                                        marginTop: '-10px'
                                                                    }}
                                                                    onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                                                    onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                                >
                                                                    <i className="fa-regular fa-trash-can text-danger me-2"></i>
                                                                    Delete
                                                                </p>
                                                            </div>
                                                        }
                                                        trigger="hover"
                                                    >
                                                        <button
                                                            className="btn"
                                                        >
                                                            <i className="fa-solid fa-ellipsis-vertical"></i>
                                                        </button>
                                                    </Popover>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="12" className="text-center">
                                                <p>No Data Available</p>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <div className="dt-paging paging_simple_numbers">
                                <nav aria-label="pagination">
                                    <ul className="pagination">
                                        <li
                                            className={`dt-paging-button page-item ${currentPage === 1 ? "disabled" : ""}`}
                                        >
                                            <button
                                                className="page-link previous"
                                                role="link"
                                                type="button"
                                                aria-controls="kt_customers_table"
                                                aria-disabled={currentPage === 1}
                                                aria-label="Previous"
                                                onClick={handlePrevious}
                                            >
                                                <i className="previous"></i>
                                            </button>
                                        </li>

                                        {/* Page Numbers */}
                                        {getPaginationNumbers().map((page, index) => (
                                            <li
                                                key={index}
                                                className={`dt-paging-button page-item ${page === currentPage ? "active" : ""}`}
                                            >
                                                <button
                                                    className="page-link"
                                                    role="link"
                                                    type="button"
                                                    aria-controls="kt_customers_table"
                                                    aria-current={page === currentPage ? "page" : undefined}
                                                    onClick={() => handlePageClick(page)}
                                                    disabled={page === "..."}
                                                >
                                                    {page}
                                                </button>
                                            </li>
                                        ))}

                                        {/* Next Button */}
                                        <li
                                            className={`dt-paging-button page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                        >
                                            <button
                                                className="page-link next"
                                                role="link"
                                                type="button"
                                                aria-controls="kt_customers_table"
                                                aria-disabled={currentPage === totalPages}
                                                aria-label="Next"
                                                onClick={handleNext}
                                            >
                                                <i className="next"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                    <div
                        className="modal fade"
                        id="imagePreviewModal"
                        tabIndex="-1"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-dialog-centered modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Image Preview</h5>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body text-center p-5">
                                    {selectedImage ? (
                                        <img
                                            src={selectedImage}
                                            alt="Enlarged Preview"
                                            className="img-fluid shadow"
                                            style={{
                                                maxHeight: '75vh',
                                                borderRadius: '8px',
                                                objectFit: 'contain'
                                            }}
                                            // Error handling if the URL is broken
                                            onError={(e) => {
                                                e.target.src = 'https://via.placeholder.com/400?text=Image+Not+Found';
                                            }}
                                        />
                                    ) : (
                                        <div className="spinner-border text-primary" role="status"></div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <AddOrganization />
                <EditOrganization editObj={editData} />
            </div>
        </MainLayout>
    )
}